import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext } from "react";
import { ListUsers } from "@/resources/User/ListUsers";
import { useRecordContext } from "react-admin";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { IPermissions } from "@/types/keycloak";
export var EditElectionEventUsers = function () {
    var _a;
    var record = useRecordContext();
    var authContext = useContext(AuthContext);
    var tenantId = useTenantStore()[0];
    var showUsers = authContext.isAuthorized(true, tenantId, IPermissions.VOTER_READ);
    var electionEventId = (_a = record === null || record === void 0 ? void 0 : record.election_event_id) !== null && _a !== void 0 ? _a : record === null || record === void 0 ? void 0 : record.id;
    var electionId = (record === null || record === void 0 ? void 0 : record.election_event_id) ? record === null || record === void 0 ? void 0 : record.id : undefined;
    if (!showUsers) {
        return null;
    }
    return _jsx(ListUsers, { electionEventId: electionEventId, electionId: electionId });
};
